import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { NotificationEvents } from 'app/common/notification.constants';
import { UserTaggedInCommentNotification } from '@twrx-api-models';
import { userTaggedInCommentReceived } from 'app/store/user-notifications/user-notifications.actions';
import { ActionResponsePayload } from 'app/store/action-response-payload';

import { SignalRService } from './base/signalr-service';

@Injectable({
	providedIn: 'root'
})
export class CommentNotificationService {
	constructor(
		private readonly signalRService: SignalRService,
		private readonly store: Store
	) {}

	public registerHandlers(): void {
		this.signalRService
			.onEvent<UserTaggedInCommentNotification>(
				NotificationEvents.UserTaggedInComment
			)
			.subscribe(notification => {
				this.store.dispatch(
					userTaggedInCommentReceived(new ActionResponsePayload(notification))
				);
			});

		console.log('[Comment Mention] signalr events registered');
	}
}
